'use es6';

import { forwardRef } from 'react';
import ErrorHandler from 'simple-menus-lib/components/ErrorHandler';
import MenuErrorState from 'simple-menus-lib/components/menu/MenuErrorState';
import { jsx as _jsx } from "react/jsx-runtime";
export default function withErrorHandler() {
  return Component => {
    const WithErrorHandler = /*#__PURE__*/forwardRef((props, ref) => {
      return /*#__PURE__*/_jsx(ErrorHandler, {
        errorComponent: /*#__PURE__*/_jsx(MenuErrorState, {}),
        children: /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
          ref: ref
        }))
      });
    });
    WithErrorHandler.displayName = `WithErrorHandler(${Component.displayName || Component.name || 'Component'})`;
    return WithErrorHandler;
  };
}